export const reference_isSnomed = (reference) => {
    return reference?.type === 'snomed';
};
export const reference_isLoinc = (reference) => {
    return reference?.type === 'loinc';
};
export const reference_isBook = (reference) => {
    return reference?.type === 'book';
};
export const reference_isArticle = (reference) => {
    return reference?.type === 'article';
};
export const reference_isUpToDate = (reference) => {
    return reference?.type === 'upToDate';
};
export const reference_isICD = (reference) => {
    return reference?.type === 'icdCode';
};
export const reference_isCPT = (reference) => {
    return reference?.type === 'cpt';
};
export const reference_isATC = (reference) => {
    return reference?.type === 'atc';
};
export const reference_isRxCUI = (reference) => reference?.type === 'rxCUI';
//# sourceMappingURL=utils.js.map